const styles = (theme) => ({
  headerStyle: {
    paddingRight: '10px',
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px'
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    cursor : "pointer"
  },
  iconLayout: {
    float: 'right',
    color: theme.iconColor,
    zIndex: 1,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  iconContainer: {
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center'
  },
  historyText: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
    textDecorationLine: 'underline',
    display: 'flex',
    alignItems: 'center',
    paddingRight: 10,
    cursor: 'pointer'
  },
  historyTextDisable: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
    textDecorationLine: 'underline',
    display: 'flex',
    alignItems: 'center',
    paddingRight: 10,
    cursor: 'not-allowed'
  },
  dropdownContainer: {
    paddingLeft: 10,
    '& .select__control': {
      border: `1px solid ${theme.iconColor}`,
      minHeight: 34,
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
    }
  }
});
export default styles;
